import React from "react";
import { SiFlutter, SiReact, SiNodedotjs, SiNextdotjs, SiPython, SiAmazonwebservices, SiDocker, SiFigma } from "react-icons/si";
import { Container, H2_SIZE } from "../home/ui";

const tech = [
  { icon: SiFlutter, label: "Flutter", cls: "text-[#42A5F5]" },
  { icon: SiReact, label: "React", cls: "text-[#22B8E8]" },
  { icon: SiNodedotjs, label: "Node.js", cls: "text-[#539E43]" },
  { icon: SiNextdotjs, label: "Next.js", cls: "text-black" },
  { icon: SiPython, label: "Python", cls: "text-[#3776AB]" },
  { icon: SiAmazonwebservices, label: "AWS", cls: "text-[#232F3E]" },
  { icon: SiDocker, label: "Docker", cls: "text-[#1D91E6]" },
  { icon: SiFigma, label: "Figma", cls: "text-[#F24E1E]" },
];

const SoftTech = () => (
  <section className="bg-white py-[32px] lg:py-[48px]">
    <Container className="max-w-[1320px]">
      <div className="relative overflow-hidden rounded-[24px] bg-gradient-to-r from-[#F7F6FF] via-[#FAFAFF] to-[#F2F6FF] px-[24px] py-[36px] max-sm:px-[14px] max-sm:py-[28px] sm:px-[40px] lg:py-[48px]">
        {/* soft decorative shapes */}
        <div className="pointer-events-none absolute -left-[60px] -top-[70px] h-[180px] w-[260px] rounded-full bg-[#ECE6FF]/80" />
        <div className="pointer-events-none absolute -bottom-[80px] -right-[40px] h-[220px] w-[320px] rounded-full bg-[#E3EDFF]/70" />
        <div className="bg-dots pointer-events-none absolute right-[30px] top-[24px] hidden h-[48px] w-[72px] opacity-70 lg:block" />

        <div className="relative grid items-center gap-[28px] lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-[32px]">
          <div>
            <span className="inline-block rounded-full bg-[#E1EAFF] px-[14px] py-[5px] text-[12px] font-semibold uppercase tracking-[0.04em] text-[#1E4DFF]">
              Technologies
            </span>
            <h2 className={`mt-[14px] font-extrabold tracking-tight text-[#0B0D2C] ${H2_SIZE}`}>
              Modern Technologies
              {" "}<br />
              <span className="text-gradient">We Work With</span>
            </h2>
          </div>

          <div className="grid grid-cols-4 gap-[12px] sm:grid-cols-8">
            {tech.map((t) => (
              <div key={t.label} className="flex flex-col items-center gap-[10px]">
                <span className="inline-flex aspect-square w-full max-w-[72px] items-center justify-center rounded-[16px] bg-white text-[34px] shadow-[0_10px_24px_-16px_rgba(40,60,140,0.4)] transition hover:-translate-y-1">
                  <t.icon className={t.cls} />
                </span>
                <span className="text-center text-[12.5px] font-medium text-[#1F2547]">{t.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  </section>
);

export default SoftTech;
